import { TicketCheckAbortedError } from '../errors';

export const isTicketCheckAbortedError = (
  error: TicketCheckAbortedError | unknown,
): error is TicketCheckAbortedError => (error instanceof TicketCheckAbortedError);
